var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3068 0H2.69701C1.2086 0 0.00195312 1.2066 0.00195312 2.69506V17.305C0.00195312 18.7934 1.20855 20 2.69701 20H9.90251L9.91479 12.8531H8.05802C7.81672 12.8531 7.62087 12.658 7.61994 12.4167L7.61104 10.1129C7.61011 9.87032 7.80655 9.67315 8.04917 9.67315H9.90256V7.44714C9.90256 4.86388 11.4803 3.45727 13.7847 3.45727H15.6757C15.9176 3.45727 16.1138 3.65341 16.1138 3.8954V5.83793C16.1138 6.07982 15.9178 6.27592 15.6759 6.27606L14.5155 6.2766C13.2622 6.2766 13.0196 6.87212 13.0196 7.74608V9.6732H15.7733C16.0357 9.6732 16.2393 9.90232 16.2084 10.1629L15.9353 12.4667C15.9092 12.6871 15.7222 12.8532 15.5003 12.8532H13.0318L13.0196 20.0001H17.3069C18.7954 20.0001 20.002 18.7935 20.002 17.3051V2.69506C20.0019 1.2066 18.7953 0 17.3068 0Z",
    fill: "#475993"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon-facebook.a5e8abc3ea468d9bde3d5379042a9aea.svg";
export { ForwardRef as ReactComponent };